module.exports = __webpack_public_path__ + "img/plus.078cd073.svg";